/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  EngagementOracle,
  EngagementOracleInterface,
} from "../../contracts/EngagementOracle";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter_",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EngagementOracle_OnlyWriter",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
    ],
    name: "TierSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "TiersReset",
    type: "event",
  },
  {
    inputs: [],
    name: "DATA_WRITER",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserTier",
    outputs: [
      {
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "resetTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "tier_",
        type: "uint8",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "tier",
            type: "uint8",
          },
        ],
        internalType: "struct IEngagementOracle.UserTierParams[]",
        name: "userTiersParams",
        type: "tuple[]",
      },
    ],
    name: "setTiersBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter_",
        type: "address",
      },
    ],
    name: "setWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type EngagementOracleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EngagementOracleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EngagementOracle__factory extends ContractFactory {
  constructor(...args: EngagementOracleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    dataWriter_: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(dataWriter_, owner_, overrides || {});
  }
  override deploy(
    dataWriter_: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(dataWriter_, owner_, overrides || {}) as Promise<
      EngagementOracle & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): EngagementOracle__factory {
    return super.connect(runner) as EngagementOracle__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EngagementOracleInterface {
    return new Interface(_abi) as EngagementOracleInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): EngagementOracle {
    return new Contract(address, _abi, runner) as unknown as EngagementOracle;
  }
}
